import {createAsyncThunk} from "@reduxjs/toolkit";
import axios from "axios";
import {USER_LOCALSTORAGE_KEY} from "../../../../shared/const/localstorage";
import {paymentDeleted} from "../../slice/payments/paymentsSlice";


export const deletePayment = createAsyncThunk(
    "payments/deletePayment",
    async (paymentId: number, thunkAPI) => {
        try {
            const authToken = localStorage.getItem(USER_LOCALSTORAGE_KEY);
            if (!authToken) {
                throw new Error('No token found in localStorage.');
            }
            const { token } = JSON.parse(authToken);

            const response = await axios.delete(`/api/payments/delete/${paymentId}`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            if (response.data.success) {
                // Обновляем состояние, удаляя платеж с указанным id
                thunkAPI.dispatch(paymentDeleted(paymentId));
                return paymentId; // Возвращаем id успешно удаленного платежа
            } else {
                throw new Error("Failed to delete payment");
            }
        } catch (error) {
            return thunkAPI.rejectWithValue("error");
        }
    }
);
